import { cmiApiCall } from "./../axios/apiClient";

const controller = "usuario";

export default {
  getUserProfile: async () => {
    let response = { success: true };
    const method = `profile`;
    try {
      const apiResponse = await cmiApiCall.get(controller, method);
      response.data = apiResponse?.data;
    } catch (error) {
      response = cmiApiCall.handleCatch(error);
    }
    return response;
  },
  fetchUsersByFilter: async (values) => {
    let response = { success: true };
    const method = `busqueda_avanzada`;
    try {
      const apiResponse = await cmiApiCall.post(controller, method, values);
      response.data = apiResponse?.data;
    } catch (error) {
      response = cmiApiCall.handleCatch(error);
    }
    return response;
  },
  updateUserWithAccess: async (values) => {
    let response = { success: true };
    const method = `userwithaccess`;
    try {
      const apiResponse = await cmiApiCall.put(controller, method, values);
      response.message = apiResponse?.data?.mensaje;
    } catch (error) {
      response = cmiApiCall.handleCatch(error);
    }
    return response;
  },
};
